import { getAdminSettings, getUserList } from "../ApiService";
import { useQuery } from "react-query";
import PageContainer from "../components/PageContainer/PageContainer";
import PageBlock from "../components/PageContainer/PageBlock";
import ManageTable from "../modules/ManageTable/ManageTable";
import LoaderCircle from "../components/LoaderCircle/LoaderCircle";
import SettingsForm from "../modules/SettingsForm/SettingsForm";
import { useState } from "react";

type Tab = "users" | "settings";
export default function ManagementPage() {
  const { data: userList, isLoading: isUsersLoading } = useQuery(
    "userList",
    getUserList
  );
  const { data: adminSettings, isLoading: isSettingsLoading } = useQuery(
    "adminSettings",
    getAdminSettings
  );
  const [activeTab, setActiveTab] = useState<Tab>("users");

  const handleTabClick = (tab: Tab) => {
    setActiveTab(tab);
  };

  return (
    <PageContainer wide={true}>
      {(isUsersLoading || isSettingsLoading) && <LoaderCircle />}
      <div className="flex flex-col gap-4">
        <PageBlock>
          <div className="flex gap-5">
            <button
              className={`bg-transparent border-none p-0 m-0 ${
                activeTab === "users" ? "underline" : ""
              }`}
              onClick={() => handleTabClick("users")}
            >
              <h3 className="h2Font">Пользователи</h3>
            </button>
            <button
              className={`bg-transparent border-none p-0 m-0 ${
                activeTab === "settings" ? "underline" : ""
              }`}
              onClick={() => handleTabClick("settings")}
            >
              <h3 className="h2Font">Настройки</h3>
            </button>
          </div>

          {activeTab === "settings" && adminSettings && (
            <SettingsForm adminSettings={adminSettings} />
          )}
          {activeTab === "users" && userList && (
            <ManageTable userList={userList} />
          )}
        </PageBlock>
      </div>
    </PageContainer>
  );
}
